const DEV = process.env.NODE_ENV === 'development'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  init() {
    const isPinned = true

    let basePath = '/wp-content/themes/lgc/assets/media/pantheon/' //1.jpg -> 9.jpg

    let frames = 9
    const wrapper = document.getElementById('pantheonCoverAnimation')
    const animatedImg = document.getElementById('pantheonCoverAnimationImg')

    if (!animatedImg) return
    const state = { frame: 1 }

    if (isPinned) {
      gsap.to(state, {
        frame: frames,
        ease: 'none',
        scrollTrigger: {
          trigger: wrapper,
          start: 'top top',
          end: '+=500',
          pin: true,
          scrub: true,
          //markers: true,
        },
        onUpdate() {
          const index = Math.round(state.frame)
          animatedImg.src = `${basePath}${index}.jpg?v=9`
        },
      })
    } else {
      gsap.to(state, {
        frame: frames,
        ease: 'none',
        scrollTrigger: {
          trigger: animatedImg,
          start: 'top top+=200px',
          end: 'bottom top',
          scrub: true,
          //markers: true,
        },
        onUpdate() {
          const index = Math.round(state.frame)
          animatedImg.src = `${basePath}${index}.jpg`
        },
      })
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
